<h5 *ngIf="isMainComponent">{{ menu?.Id ? "Edit" : "New" }} Menu</h5>
<div class="p-fluid flex flex-column ">
  <div class="field">
    <label htmlFor="name">Name</label>
    <input pInputText id="name" type="text" [(ngModel)]="menu.Name" />
  </div>

  <div class="field">
    <p-checkbox binary="true" name="hidden" label="Hidden" [ngModel]="menu.Hidden"
      (ngModelChange)="menu.Hidden = $event"></p-checkbox>
  </div>

  <div class="field">
    <p-checkbox binary="true" name="half" label="Support Half And Half?" [ngModel]="menu.HalfAndHalfPrice != null"
      (ngModelChange)="menu.HalfAndHalfPrice = $event ? 0 : null"></p-checkbox>
  </div>
  <div class="field" *ngIf="menu.HalfAndHalfPrice != null">
    <label for="half">Extra added price for Half&Half</label>
    <input pInputText type="number" name="halfandhalf" [(ngModel)]="menu.HalfAndHalfPrice" />
  </div>
  <div>
    <h6>Extra added price for order source</h6>
    <div class="p-formgrid grid p-fluid align-items-end tw-max-w-lg"
      *ngFor="let item of menu.SourcePrice; let index = index">
      <div class="field col-12 md:col-5">
        <label htmlFor="type">Order Source</label>
        <p-dropdown [options]="orderSources" [(ngModel)]="item.Source"></p-dropdown>
      </div>
      <div class="field col-12 md:col-5">
        <label htmlFor="price">Extra Price</label>
        <input pInputText type="number" [(ngModel)]="item.Price" />
      </div>
      <div class="field col-12 md:col-2">
        <p-button icon="pi pi-trash" severity="danger" [text]="true"
          (click)="menu.SourcePrice.splice(index, 1)"></p-button>
      </div>
    </div>
    <div class="tw-flex tw-justify-end">
      <p-button label="Add new source price" icon="pi pi-plus" severity="success" (click)="menu.SourcePrice.push({})"
        size="small" [outlined]="true"></p-button>
    </div>

  </div>

  <div class="field">
    <label for="tags">Tags</label>
    <brt-tag-selector id="tags" [(ngModel)]="menu.Tags" [businessId]="menu.BusinessId"
      [canAdd]="true"></brt-tag-selector>
  </div>

  <div class="field">
    <p-fieldset legend="UI Settings" [toggleable]="true" [collapsed]="true">
      <brt-ui-settings id="ui" [(ngModel)]="menu.UI"
        [keys]="['Image:image:ai:menu-image:' + menu.Id, 'Description:text']" [business-id]="menu.BusinessId">
      </brt-ui-settings>
    </p-fieldset>
  </div>
</div>

<div class="tw-flex tw-gap-2">
  <button pButton pRipple label="Save" (click)="save()"></button>
  <button *ngIf="!saved.observed && menu?.Id" pButton pRipple label="Apply" class="p-button-secondary"
    (click)="save(false)"></button>
</div>